<template>
	<footer id="footer">
			<div class="footerWrap">
				<div class="footerBox">
					<div class="footerTxt">
						<address>서울시 강남구 강남대로 382 메리츠타워</address>
						<p class="fax">FAX 0505-021-7711</p>
					</div>
					<div class="family">
						<button type="button">메리츠금융가족<span class="ico_arr"></span></button>
						<ul>
							<li><a href="http://www.meritzfire.com" target="_blank" title="새창열기"><span>메리츠화재</span></a></li>
							<li><a href="http://www.imeritz.com" target="_blank" title="새창열기"><span>메리츠증권</span></a></li>
							<li><a href="http://www.meritzcapital.com" target="_blank" title="새창열기"><span>메리츠캐피탈</span></a></li>
							<li><a href="http://www.meritzaim.co.kr" target="_blank" title="새창열기"><span>메리츠대체투자운용</span></a></li>
						</ul>
					</div>  
				</div>
				<div class="footerBox">
					<div class="footerLink">
						<ul>
							<li><a  target="_blank" title="새창열기" href="http://www.meritzgroup.com/web/ko/etc/etc1.do"><span>공시정보관리지침</span></a></li>
							<li><a  target="_blank" title="새창열기" href="http://www.meritzgroup.com/web/ko/etc/etc2_1.7.do" class="fw700"><span>개인정보처리방침</span></a></li>
							<li><a  target="_blank" title="새창열기" href="http://www.meritzgroup.com/web/ko/etc/etc3.do"><span>고객정보취급방침</span></a></li>
							<li><a  target="_blank" title="새창열기" href="http://www.meritzgroup.com/web/ko/etc/etc4.do"><span>신용정보활용체제</span></a></li>
						</ul>
					</div>
					<p class="copyright">© 메리츠금융그룹. ALL Rights Reserved.</p>
				</div>
			</div>
		</footer>
</template>

<script setup>

</script>